import { Form, Row, Col, DatePicker, Input, Radio, Button } from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";

const Index = ({setActive}) => {
  const [form] = Form.useForm();
  const [showInput, setShowInput] = useState(false);
  const [closing, setClosing] = useState(false);
  const [emd, setEmd] = useState(false);
  const [list, setList] = useState(false);
  const [seller, setSeller] = useState(false);

  const EMDchanges = (e) => {
    if (e.target.value == "total_emd") {
      setEmd(true);
      setList(false);
      setSeller(false);
    } else if (e.target.value == "listing_broker") {
      setList(true);
      setEmd(false);
      setSeller(false);
    } else if (e.target.value == "sellers_attorney") {
      setSeller(true);
      setList(false);
      setEmd(false);
    }
  };

  const handleRadioChange = (e) => {
    console.log(e.target.value);
    if (e.target.value == "escrowee_send_deposit_to_seller") {
      setShowInput(true);
      setClosing(false);
    } else if (e.target.value == "closing_atorney_buyer") {
      setClosing(true);
      setShowInput(false);
    }
  };

  const onSub = async (values) => {
    setActive(true)
    console.log(values);
    let res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/listing-commission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Listing Commission"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false)
  };
  return (
    <div className="main">
      <Form form={form} onFinish={onSub} autoComplete="off">
        <Row>
          <Col md={12}>
            <label>Closing Date</label>
            <Form.Item
              name="closing_date"
              rules={[{ required: true, message: "required" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={12}>
            {" "}
            <label>Property Address</label>
            <Form.Item
              name="propert_address"
              rules={[{ required: true, message: "required" }]}
            >
              <TextArea rows={3} style={{ resize: "none" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-between"}>
          <Col md={12}>
            <label>Seller Name</label>
            <Form.Item
              name="seller_name"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Seller Name" />
            </Form.Item>
          </Col>
          <Col md={12}>
            {" "}
            <label>Buyer Name</label>
            <Form.Item
              name="buyer_name"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Buyer Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-between"}>
          <Col md={12}>
            <label>Listing Brokerage</label>
            <Form.Item
              name="listing_brokerage"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Listing Brokerage" />
            </Form.Item>
          </Col>
          <Col md={12}>
            {" "}
            <label>Listing Broker & License #</label>
            <Form.Item
              name="listnig_broker"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Listing Broker" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-between"}>
          <Col md={12}>
            <label>Selling Brokerage</label>
            <Form.Item
              name="selling_brokerage"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Selling Brokerage" />
            </Form.Item>
          </Col>
          <Col md={12}>
            {" "}
            <label>Selling Broker</label>
            <Form.Item
              name="selling_broker"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Selling Broker" />
            </Form.Item>
          </Col>
        </Row>
        <label>Escrowee</label>
        <Form.Item
          name={"escrowee"}
          rules={[{ required: true, message: "required" }]}
        >
          <Radio.Group style={{ width: "100%" }} onChange={EMDchanges}>
            <Row>
              <Col md={4}>
                <Radio value="listing_broker">Listing Broker</Radio>
                {list && (
                  <>
                    <Form.Item name={"listing_broker_amount"}>
                      <Input placeholder="0.00$" />
                    </Form.Item>
                  </>
                )}
              </Col>
              <Col md={4}>
                <Radio value="sellers_attorney">Seller Attorney</Radio>
                {seller && (
                  <>
                    <Form.Item name={"sellers_attorney_amount"}>
                      <Input placeholder="0.00$" />
                    </Form.Item>
                  </>
                )}
              </Col>
              <Col md={4}>
                <Radio value="total_emd">Total EMD</Radio>
                <div>
                  {emd && (
                    <>
                      <Form.Item name={"total_emd_amount"}>
                        <Input placeholder="0.00$" />
                      </Form.Item>
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Radio.Group>
        </Form.Item>
        <hr />

        <div>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              <label>1) Contract Purchase Price</label>
              <Form.Item
                name={"contract_purchase_price"}
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>2) Commissionable Net Sales Price</label>
              <Form.Item
                name={"commissionable_net_sales_price"}
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              <label>3) Listing Brokerage Commission</label>
              <Form.Item
                name={"brokerage_commission"}
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}>
              <label>4) Seller Compensation to Buyer Brokerage</label>
              <Form.Item
                name={"seller_commission"}
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} justify={"space-between"}>
            <Col md={10}>
              {" "}
              <label>5) Buyer Contribution to Buyer Broker Compensation</label>
              <Form.Item
                name={"buyer_commission"}
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}>
              {" "}
              <label>6) Total Compensation to Buyer Brokerage</label>
              <Form.Item
                name={"total_compensation"}
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Form.Item
          name={"escrowee_payment_method"}
          rules={[{ required: true, message: "required" }]}
        >
          <Radio.Group onChange={handleRadioChange}>
            <Row>
              <Col md={24}>
                <Radio value="escrowee_send_deposit_to_seller">
                  Escrowee will send excess deposit to seller
                </Radio>
              </Col>
            </Row>

            <Row>
              <Col md={24}>
                <Radio value="closing_atorney_buyer">
                  Closing Attorney pays Buyer Brokerage directly
                </Radio>
              </Col>
            </Row>
          </Radio.Group>
        </Form.Item>
        {showInput && (
          <Form.Item
            name={"escrowee_deposit_amount"}
            rules={[{ required: true, message: "required" }]}
          >
            <Input placeholder="$" style={{ width: "50%" }} />
          </Form.Item>
        )}
        {closing && (
          <Form.Item
            name={"closing_atorney_amount"}
            rules={[{ required: true, message: "required" }]}
          >
            <Input placeholder="$" style={{ width: "50%" }} />
          </Form.Item>
        )}
        <hr />
        <div>
          <Row gutter={16} justify={"space-between"}>
            <Col md={6}>
              <label>Reimbursement to</label>
              <Form.Item
                name="reimbursement_to"
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="name" />
              </Form.Item>
            </Col>
            <Col md={6}>
              <label>Reimbursement amount</label>
              <Form.Item
                name="reimbursement_amount"
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="$" />
              </Form.Item>
            </Col>
            <Col md={10}></Col>
          </Row>

          <Row gutter={16} justify={"space-between"}>
            <Col md={5}>
              {" "}
              <label>Federal Tax ID</label>
              <Form.Item name="federal_tax_id" initialValue={"45-3673820"}>
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col md={6}>
              {" "}
              <label>MA Real Estate Board License</label>
              <Form.Item
                name="ma_real_estate_board_license"
                initialValue={"9799"}
              >
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col md={6}>
              {" "}
              <label>MA Broker’s License</label>
              <Form.Item name="ma_broker_license" initialValue={"9519238"}>
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col md={6}>
              <label>RI Broker’s License</label>
              <Form.Item name="ri_broker_license" initialValue={"REB.0018693"}>
                <Input readOnly />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
